/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SegmentationInputs */

const en_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentation`)
};

const ar_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقسيم`)
};

const bn_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেগমেন্টেশন`)
};

const de_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentierung`)
};

const es_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentación`)
};

const fr_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentation`)
};

const pt_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentação`)
};

const zh_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分组`)
};

const tr_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentasyon`)
};

const ru_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегментация`)
};

const pl_svchip_segmentation = /** @type {(inputs: Svchip_SegmentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentacja`)
};

/**
* | output |
* | --- |
* | "Segmentation" |
*
* @param {Svchip_SegmentationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_segmentation = /** @type {((inputs?: Svchip_SegmentationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SegmentationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_segmentation(inputs)
	if (locale === "bn") return bn_svchip_segmentation(inputs)
	if (locale === "de") return de_svchip_segmentation(inputs)
	if (locale === "es") return es_svchip_segmentation(inputs)
	if (locale === "fr") return fr_svchip_segmentation(inputs)
	if (locale === "pt") return pt_svchip_segmentation(inputs)
	if (locale === "zh") return zh_svchip_segmentation(inputs)
	if (locale === "tr") return tr_svchip_segmentation(inputs)
	if (locale === "ru") return ru_svchip_segmentation(inputs)
	if (locale === "pl") return pl_svchip_segmentation(inputs)
	return en_svchip_segmentation(inputs)
});